export const isDocumentsDomain = (hostname: string) => {
    const host = hostname.split('.');
    const rootDomain = host.length > 3 ? host[1] : host[0];

    return rootDomain.includes('doc');
};
